import { createSelector } from '@reduxjs/toolkit';
import { UserReportsEntity } from '@interpals/api-web';

import { ReduxState } from 'redux/root-reducer';

const selectSelf = (state: ReduxState) => state.moderation;

export const selectReports = createSelector(selectSelf, (moderation) => moderation.reports);
export const selectUserReports = createSelector(
    [selectSelf, (_, uid: string) => uid],
    (moderation, uid: string): UserReportsEntity | undefined => {
        const index = moderation.reports.findIndex((item) => item.account.id === uid);

        return moderation.reports[index];
    },
);

export const selectReportsTotal = createSelector(selectSelf, (moderation) => moderation.total);
export const selectReportsFilter = createSelector(selectSelf, (moderation) => moderation.filters);

export const selectModRecentContent = createSelector(selectSelf, (moderation) => moderation.recentContent.content);
export const selectModRecentContentHasMore = createSelector(
    selectSelf,
    (moderation) => moderation.recentContent.hasMore,
);

export const selectLogItemsByUid = createSelector([selectSelf, (_, uid: string) => uid], (moderation, uid: string) => {
    return moderation.reports.find((item) => item.account.id === uid)?.log ?? [];
});
export const selectLogItemsByUidHasMore = createSelector(
    [selectSelf, (_, uid: string) => uid],
    (moderation, uid: string) => {
        return moderation.reports.find((item) => item.account.id === uid)?.logHasMore;
    },
);
